// @react-compiler enable
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import type {LinkedPullRequest} from '../../../api/common-contracts'
import {ItemType} from '../../../api/memex-items/item-type'
import {type ColumnValue, isEmpty, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {PillPlaceholder} from '../../common/placeholders'
import {LinkedPullRequestList} from '../../fields/linked-pr-list'
import {BaseCell} from '../cells/base-cell'
import {LinkedPullRequestGroup} from '../cells/linked-pull-requests-group'
import {useRecordCellRenderer} from '../performance-measurements'

type Props = Readonly<{
  currentValue: ColumnValue<Array<LinkedPullRequest>>
  model: MemexItemModel
}>

export const LoadingLinkedPullRequestsCell = () => (
  <BaseCell>
    <PillPlaceholder minWidth={30} maxWidth={60} {...testIdProps('placeholder')} />
  </BaseCell>
)

export const LinkedPullRequestsRenderer = memo(function LinkedPullRequestsRenderer({currentValue, model}: Props) {
  useRecordCellRenderer('LinkedPullRequestsRenderer', model.id)

  if (isLoading(currentValue)) {
    return <LoadingLinkedPullRequestsCell />
  }

  if (model.contentType === ItemType.DraftIssue || isEmpty(currentValue)) {
    return null
  }

  const linkedPullRequests = currentValue.value

  if (linkedPullRequests.length > 1) {
    return <LinkedPullRequestList linkedPullRequests={linkedPullRequests} />
  }

  return <LinkedPullRequestGroup linkedPullRequests={currentValue.value} />
})

try{ LoadingLinkedPullRequestsCell.displayName ||= 'LoadingLinkedPullRequestsCell' } catch {}
try{ LinkedPullRequestsRenderer.displayName ||= 'LinkedPullRequestsRenderer' } catch {}